/* loaded by smart-asset */
export default require("./navigate_next-24px~uvOcRiRh.svg")